let datasetId: string | null = null

export function initDatasetFromQuery() {
    const params = new URLSearchParams(window.location.search)
    const id = params.get('dataset')
    if (id) datasetId = id
}

export function getDatasetId(): string | null {
    return datasetId
}